<template>
  <div>
    <div v-if="permisoVisualizador != '11'" class="d-flex flex-column contenido">
      <div class="" v-if="false">
        <img width="0%" height="55" src="@/assets/imagenesPlataform/cumpleaños.png" alt="" />
      </div>

      <!-- plataformas de perfil profesional -->

      <div class="text-center">
        <strong class="tamañao titulo1 pb-0 my-0 pt-0" style="font-size: 1.23rem">
          Topás es la plataforma dedicada a la gestión de personal
        </strong>
        <p class="mb-1 pb-1 pregunta">¿Qué actividad deseas hacer hoy?</p>
      </div>

      <div class="hrtamaño container mb-4"></div>

      <!-- Categorias para escoger para escoger Plataforma -->
      <!-- v-if="EstadoPlataformaOperacional"-->
      <div v-if="EstadoPlataformaOperacional" class="container">
        <!-- v-if="trabacceso != '0' " -->
        <div class="row gy-2 gx-2" v-if="trabacceso != '0' && permisoVisualizador != 11">
          <div v-for="items in operacionalesVisibles"
            :key="items.idImage"
            class="col-12 col-xxl-3 col-xl-3 col-lg-3 col-md-6 col-sm-6">
            <div class="card card-plataforma-blanca ">

              <img @click="Seleccion(items.plat)" alt="" :src="items.image" class="custom-image" />

              <div class="contenedor-boton">
                <div class="boton-plataforma">
                  {{ items.titulo }}
                </div>
              </div>
            </div>
            <!-- antes se utilizaba esta validacion cuando habia menos variables de dos digitas -->
            <!-- items.plat
                  .toString()
                  .split('')
                  .some((num) => plataformitas.includes(num) -->
            <!-- {{ items }} -->
            <br />
            <br />
            <!-- <div>
              {{ plataformitas.includes(items.plat.toString()) }}
            </div> -->

          </div>
        </div>
      </div>
    </div>

    <!-- Postulante -->
  <!-- <div v-if="permisoVisualizador == '11' " class="container mt-4">
  <div class="row justify-content-center">

    <div
     v-for="(postulante, index) in pasosVisibles "
      :key="index"
      class="col-md-6 col-lg-6 mb-4 d-flex justify-content-center"
    >
      <b-card  no-body class="custom-step-card">

        <div class="icon-container">

          <svg
            v-if="index == 0"
            @click="ObservarDatos(idSolxPostulante)"
            :xmlns="xmlns[index].url"
            width="96"
            height="96"
            class="cursor text-primary"
            :class="xmlns[index].clase"
            viewBox="0 0 16 16"
            fill="currentColor"
          >
            <path :d="xmlns[index].d" />
            <path :d="xmlns[index].d1" />
          </svg>

  
          <svg
            v-if="index == 1"
            @click="Documentos(idSolxPostulante)"
            :xmlns="xmlns[index].url"
            width="96"
            height="96"
            class="cursor text-secondary"
            :class="xmlns[index].clase"
            viewBox="0 0 16 16"
            fill="currentColor"
          >
            <path :d="xmlns[index].d" />
            <path :d="xmlns[index].d1" />
          </svg>

         
          <svg
            v-if="index == 2"
            @click="Capacitaciones(idSolxPostulante)"
            :xmlns="xmlns[index].url"
            width="96"
            height="96"
            class="cursor text-warning"
            :class="xmlns[index].clase"
            viewBox="0 0 16 16"
            fill="currentColor"
          >
            <path :d="xmlns[index].d" />
            <path :d="xmlns[index].d1" />
          </svg>

         
          <svg
            v-if="index == 3"
            @click="Documentos(idSolxPostulante)"
            :xmlns="xmlns[index].url"
            width="96"
            height="96"
            class="cursor text-success"
            :class="xmlns[index].clase"
            viewBox="0 0 16 16"
            fill="currentColor"
          >
            <path :d="xmlns[index].d" />
            <path :d="xmlns[index].d1" />
          </svg>

          <svg
            v-if="index == 4 "
            @click="Contratos(idSolxPostulante)"
            :xmlns="xmlns[index].url"
            width="96"
            height="96"
            class="cursor text-success"
            :class="xmlns[index].clase"
            viewBox="0 0 16 16"
            fill="currentColor"
          >
            <path :d="xmlns[index].d" />
            <path :d="xmlns[index].d1" />
          </svg>

        </div>

      
        <div class="card-footer-title">
          {{ postulante }}  {{ firma }}
        </div>

      </b-card>
    </div>

  </div>
</div> -->

<div v-if="permisoVisualizador == '11'" class="container mt-4">
  <div class="row justify-content-center">
    
    <template v-for="(postulante, index) in Postulante">
      
      <div
        v-if="index !== 4 || (index === 4 && (firma === true || firma === 'true'))"
        :key="index"
        class="col-md-6 col-lg-6 mb-4 d-flex justify-content-center"
      >
        <b-card no-body class="custom-step-card cursor" @click="irAlPaso(index)">
          <div class="icon-container">
            <svg v-if="index == 0" :xmlns="xmlns[index].url" width="96" height="96" class="text-primary" :class="xmlns[index].clase" viewBox="0 0 16 16" fill="currentColor">
              <path :d="xmlns[index].d" /><path :d="xmlns[index].d1" />
            </svg>

            <svg v-if="index == 1" :xmlns="xmlns[index].url" width="96" height="96" class="text-secondary" :class="xmlns[index].clase" viewBox="0 0 16 16" fill="currentColor">
              <path :d="xmlns[index].d" /><path :d="xmlns[index].d1" />
            </svg>

            <svg v-if="index == 2" :xmlns="xmlns[index].url" width="96" height="96" class="text-warning" :class="xmlns[index].clase" viewBox="0 0 16 16" fill="currentColor">
              <path :d="xmlns[index].d" /><path :d="xmlns[index].d1" />
            </svg>

            <svg v-if="index == 3" :xmlns="xmlns[index].url" width="96" height="96" class="text-success" :class="xmlns[index].clase" viewBox="0 0 16 16" fill="currentColor">
              <path :d="xmlns[index].d" /><path :d="xmlns[index].d1" />
            </svg>

            <svg v-if="index == 4" :xmlns="xmlns[index].url" width="96" height="96" class="text-success" :class="xmlns[index].clase" viewBox="0 0 16 16" fill="currentColor">
              <path :d="xmlns[index].d" /><path :d="xmlns[index].d1" />
            </svg>
          </div>

          <div class="card-footer-title">
            {{ postulante }}
          </div>
        </b-card>
      </div>
    </template>

  </div>
</div>

    <!-- Espacio Personal del trabajador == 1 y postulante -->
    <div v-if="EstadoBotonPostulacion" class="d-flex flex-wrap container">
      datos del postulante validaciones
    </div>

    <!-- Espacio perfil Personal del trabajador == 1 -->
    <div v-if="
      permisoVisualizador !== '11' &&
      Trabacceso == 1 &&
      EstadoPlataformaPersonal
    " class="d-flex flex-wrap container">
      <div class="mb-4 mt-5">
        <h2 class="fw-bold">Tu Espacio Personal</h2>
        <p class="text-muted">
          Bienvenido(a). En este espacio podrás consultar toda la información
          relacionada contigo: tus datos personales, contratos, boletas de pago,
          historial de vacaciones y preguntas frecuentes. Aquí tienes acceso a
          todo tu legajo digital de forma clara y ordenada.ss
        </p>
      </div>

      <div class="container">
        <div class="row gy-2 gx-2">
          <div v-for="items in personalEstado0"
            :key="items.idImage"
            class="col-12 col-xxl-3 col-xl-3 col-lg-3 col-md-6 col-sm-6">
            <div class="card card-plataforma-blanca ">

              <img @click="Seleccion(items.plat)" alt="" :src="items.image" class="custom-image" />

              <div class="contenedor-boton">
                <div class="boton-plataforma">
                  {{ items.titulo }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Espacio Personal del trabjador == 0 -->
    <div v-if="permisoVisualizador !== '11' && Trabacceso == 0" class="d-flex flex-wrap container">
      <div class="mb-4 mt-5">
        <h2 class="fw-bold">Tu Espacio Personal</h2>
        <p class="text-muted">
          Bienvenido(a). En este espacio podrás consultar toda la información
          relacionada contigo: tus datos personales, contratos, boletas de pago,
          historial de vacaciones y preguntas frecuentes. Aquí tienes acceso a
          todo tu legajo digital de forma clara y ordenada.
        </p>
      </div>

      <div class="container">
        <div class="row gy-2 gx-2">
          <div v-for="items in personalSolo9"
            :key="items.idImage"
            class="col-12 col-xxl-3 col-xl-3 col-lg-3 col-md-6 col-sm-6">
            <img @click="Seleccion(items.plat)" alt="" :src="items.image"
              class="custom-image" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { ref } from "vue";
export default {
  name: "SolimanologPlataformaConexion",

  data() {
    return {
      permisoVisualizador: "",
      idSolxPostulante: "",
      trabacceso: "",
      documento: [], // tus datos llenados por API o local
      NUM_RESULTS: 6,
      isMobile: window.innerWidth <= 768,
      url: "https://apitopas.gruposolimano.com.pe/Documentos/Contratos/",
      plataformitas: [],
      PermisoPerfil: false,
      usuAuxiliar: "",
      firma:false,

      xmlns: [
        {
          url: `http://www.w3.org/2000/svg`,
          clase: `bi bi-person-vcard`,
          d: "M5 8a2 2 0 1 0 0-4 2 2 0 0 0 0 4Zm4-2.5a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1-.5-.5ZM9 8a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 0 1h-4A.5.5 0 0 1 9 8Zm1 2.5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5Z",
          d1: "M2 2a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H2ZM1 4a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1H8.96c.026-.163.04-.33.04-.5C9 10.567 7.21 9 5 9c-2.086 0-3.8 1.398-3.984 3.181A1.006 1.006 0 0 1 1 12V4Z",
          click: "ObservarDatos",
        },

        {
          url: `http://www.w3.org/2000/svg`,
          clase: `bi bi-file-earmark-arrow-up`,
          d: "M8.5 11.5a.5.5 0 0 1-1 0V7.707L6.354 8.854a.5.5 0 1 1-.708-.708l2-2a.5.5 0 0 1 .708 0l2 2a.5.5 0 0 1-.708.708L8.5 7.707V11.5z",
          d1: "M14 14V4.5L9.5 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2zM9.5 3A1.5 1.5 0 0 0 11 4.5h2V14a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h5.5v2z",
          click: "Documentos",
        },
        {
          url: `http://www.w3.org/2000/svg`,
          clase: `bi bi-mortarboard`,
          d: "M8.211 2.047a.5.5 0 0 0-.422 0l-7.5 3.5a.5.5 0 0 0 .025.917l7.5 3a.5.5 0 0 0 .372 0L14 7.14V13a1 1 0 0 0-1 1v2h3v-2a1 1 0 0 0-1-1V6.739l.686-.275a.5.5 0 0 0 .025-.917l-7.5-3.5ZM8 8.46 1.758 5.965 8 3.052l6.242 2.913L8 8.46Z",
          d1: "M4.176 9.032a.5.5 0 0 0-.656.327l-.5 1.7a.5.5 0 0 0 .294.605l4.5 1.8a.5.5 0 0 0 .372 0l4.5-1.8a.5.5 0 0 0 .294-.605l-.5-1.7a.5.5 0 0 0-.656-.327L8 10.466 4.176 9.032Zm-.068 1.873.22-.748 3.496 1.311a.5.5 0 0 0 .352 0l3.496-1.311.22.748L8 12.46l-3.892-1.556Z",
          click: "Capacitacion",
        },

         {
          url: `http://www.w3.org/2000/svg`,
          clase: `bi bi-prescription2`,
          d: "M7 6h2v2h2v2H9v2H7v-2H5V8h2z",
          d1: "M2 1a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1v10.5a1.5 1.5 0 0 1-1.5 1.5h-7A1.5 1.5 0 0 1 3 14.5V4a1 1 0 0 1-1-1zm2 3v10.5a.5.5 0 0 0 .5.5h7a.5.5 0 0 0 .5-.5V4zM3 3h10V1H3z",
          click: "Logro",
        },

        {
          url: `http://www.w3.org/2000/svg`,
          clase: `bi bi-award`,
          d: "M9.669.864 8 0 6.331.864l-1.858.282-.842 1.68-1.337 1.32L2.6 6l-.306 1.854 1.337 1.32.842 1.68 1.858.282L8 12l1.669-.864 1.858-.282.842-1.68 1.337-1.32L13.4 6l.306-1.854-1.337-1.32-.842-1.68L9.669.864zm1.196 1.193.684 1.365 1.086 1.072L12.387 6l.248 1.506-1.086 1.072-.684 1.365-1.51.229L8 10.874l-1.355-.702-1.51-.229-.684-1.365-1.086-1.072L3.614 6l-.25-1.506 1.087-1.072.684-1.365 1.51-.229L8 1.126l1.356.702 1.509.229z",
          d1: "M4 11.794V16l4-1 4 1v-4.206l-2.018.306L8 13.126 6.018 12.1 4 11.794z",
          click: "Logro",
        },

       
      ],
      imagenes: ref([
        {
          idImage: 1,
          image: require("@/assets/imagenesPlataform/Seleccion1.png"),
          plat: 1,
          estado: 1,
          titulo: "PLATAFORMA DE SELECCION"
        },
        {
          idImage: 2,
          image: require("@/assets/imagenesPlataform/contrato1.png"),
          plat: 3,
          estado: 1,
          titulo: "CONTRATOS Y FICHA DEL PERSONAL"

          // 3
        },
        {
          idImage: 3,
          image: require("@/assets/imagenesPlataform/bienestar1.png"),
          plat: 11,
          estado: 1,
          titulo: "PLATAFORMA DE BIENESTAR"

          // 9
        },
        {
          idImage: 4,
          image: require("@/assets/imagenesPlataform/sst1.png"),
          plat: 4,
          estado: 1,
          titulo: "PLATAFORMA DE SST"
        },

        {
          idImage: 5,
          image: require("@/assets/imagenesPlataform/tesoreria1.png"),
          plat: 5,
          estado: 1,
          titulo: "PLATAFROMA DE TESORERIA"
        },

        {
          idImage: 6,
          image: require("@/assets/imagenesPlataform/contabilidad1.png"),
          plat: 6,
          estado: 1,
          titulo: "PLATAFROMA DE CONTABILIDAD"
        },
        {
          idImage: 7,
          image: require("@/assets/imagenesPlataform/tecnologia1.png"),
          plat: 7,
          estado: 1,
          titulo: "TECNOLOGIA"
        },
        {
          idImage: 8,
          image: require("@/assets/imagenesPlataform/nominas1.png"),
          plat: 8,
          estado: 1,
          titulo: "PLATAFORMA DE NOMINAS"

        },

        {
          idImage: 9,
          image: require("@/assets/imagenesPlataform/perfil1.png"),
          plat: 9,
          estado: 0,
          titulo: "PERFIL PERSONAL"
        },

        {
          idImage: 10,
          image: require("@/assets/imagenesPlataform/enfermeria1.png"),
          plat: 10,
          estado: 1,
          titulo: "PLATAFORMA DE ENFERMERIA"

        },

        {
          idImage: 11,
          image: require("@/assets/imagenesPlataform/bienestar1.png"),
          plat: 12,
          estado: 1,
          titulo: "PLATAFORMA DE TICKETS"

        },
        //  {
        //   idImage: 11,
        //   image: require("@/assets/imagenesPlataform/enfermeria.png"),
        //   // plat: 11,
        //   estado:1
        // },
      ]),
    };
  },

  created() {
    this.idSolxPostulante = localStorage.getItem("idSolxPostulante");
    this.permisoVisualizador = localStorage.getItem("idPerfil");
    this.usuAuxiliar = localStorage.getItem("usuAuxiliar");
    this.trabacceso = localStorage.getItem("trabacceso");
    this.firma = localStorage.getItem('firma')

    // Al entrar o regresar al Dashboard, nos aseguramos de que el Navbar esté visible

    if (this.permisoVisualizador == 11) {
      localStorage.setItem("catPlataforma", 1);
    }

    let cadenaPlataformas = localStorage.getItem("plataformasDisponibles");

    if (cadenaPlataformas) {
      // Dividir la cadena en un array usando la coma como separador
      this.plataformitas = cadenaPlataformas.split(",");

      console.log(this.plataformitas); // Mostrar el array en la consola
    } else {
      console.error("La cadena de plataformas es nula o vacía.");
    }
  },

  computed: {
    ...mapGetters("users", ["Postulante", "ListadoContratosInicio"]),
    ...mapGetters("auth", ["Trabacceso"]),

    ...mapGetters("acciones", [
      "EstadoPlataformaOperacional",
      "EstadoPlataformaPersonal",
      "EstadoDeBotonUsuarios",
      "EstadoBotonPostulacion",
    ]),

    // Filtrado para la sección operacional
    operacionalesVisibles() {
      return this.imagenes.filter(item => 
        this.plataformitas.includes(item.plat.toString()) && item.estado !== 0
      );
    },

    // Filtrado para Tu Espacio Personal (estado 0)
    personalEstado0() {
      return this.imagenes.filter(item => item.estado === 0);
    },

    // Filtrado específico para plataforma 9
    personalSolo9() {
      return this.imagenes.filter(item => item.plat.toString() === '9');
    },

  pasosVisibles() {
    // Si Postulante no ha cargado, devolvemos un array vacío
    if (!this.Postulante) return [];

    return this.Postulante.filter((item, index) => {
      // LOGICA: Si NO es el paso 4, lo dejamos pasar siempre.
      if (index !== 4) return true;
      
      // Si ES el paso 4, evaluamos la firma estrictamente.
      // Aquí forzamos que firma sea evaluado como booleano verdadero.
      return this.firma == true ;
    });
  }
  },

  methods: {
    ...mapActions("acciones", ["PlataformaCategoria"]),

    ...mapActions("users", ["getAttributes"]),

    irAlPaso(index) {
      const id = this.idSolxPostulante;
      if (index === 0) this.ObservarDatos(id);
      else if (index === 1) this.Documentos(id);
      else if (index === 2) this.Capacitaciones(id);
      else if (index === 3) this.DocumnetosFirmas(id);
      else if (index === 4) this.Contratos(id);
    },

    Seleccion(idPlataforma) {
      this.$router.push("/bienvenido");
      localStorage.setItem("catPlataforma", idPlataforma);
      localStorage.setItem("plataformaEscogida", idPlataforma); // Guardamos también en plataformaEscogida

      // Ocultar el Navbar vertical específicamente cuando se elige la Plataforma 12 (Tickets)
      if (idPlataforma == 12) {
        this.$store.dispatch("acciones/CambioNavbar", false);
      } else {
        this.$store.dispatch("acciones/CambioNavbar", true);
      }

      this.PlataformaCategoria();
      this.getAttributes();
    },

    mostrar() {
      this.$router.push("/postulante");
    },

    ObservarDatos(id) {
      this.$router.push("/EditadoSeleccion/" + id);
      window.scroll(0, 0);
    },

    Documentos(id) {
      this.$router.push("/datosDocmuentos/" + id);
      window.scroll(0, 0);
    },
    DocumnetosFirmas(id){
      this.$router.push("/datosDocumentosFirmas/" + id);
      window.scroll(0, 0);

    },

    Contratos(id) {
      this.$router.push("/selectContrato/" + id);
      window.scroll(0, 0);
    },

    Capacitaciones(id) {
      this.$router.push("/datosCapacitaciones/" + id);
      window.scroll(0, 0);
    },

    onSlideStart() {
      this.sliding = true;
    },
    onSlideEnd() {
      this.sliding = false;
    },

    listado() {
      this.$router.push("/listado");
    },
  },
};
</script>

<style scoped>
.card-plataforma-blanca {
  background: #ffffff;
  border: 1px solid #c3c1c1;
  border-radius: 0px;
  padding: 10px;
  transition: all 0.3s ease;
  cursor: pointer;

}

.card-plataforma-blanca:hover {
  box-shadow: 0 10px 24px rgba(0, 0, 0, 0.15);
  transform: translateY(-4px);
}


.img-plataforma-blanca {
  width: 100%;
  height: 200px;
  object-fit: cover;
  border-radius: 4px;
}


.contenedor-boton {
  display: flex;
  justify-content: center;
  margin-top: -18px;

}


.boton-plataforma {
  background: linear-gradient(135deg, #1e88e5, #1565c0);
  color: white;
  font-weight: 600;
  font-size: 13px;
  padding: 10px 18px;
  border-radius: 4px;
  text-align: center;
  text-transform: uppercase;
  box-shadow: 0 6px 14px rgba(0, 0, 0, 0.2);
}

.contenido {
  height: 100%;
  overflow-y: hidden;
}

.custom-image {
  width: 100%;
  height: 100%;

}

.hrtamaño {
  width: 80px;
  height: 2px;
  background: #537473;
}

.bg-solimano {
  background: #0080c8;
}

@media (max-width: 1276px) {
  .custom-image {
    /* margin-right: 20%;
    margin-left: 20%; */
    width: 100%;
    height: 250px;
  }
}
.custom-step-card {
  width: 100%;
  max-width: 420px;
  height: 260px;
  border-radius: 10px;
  border: 1px solid #e0e0e0;
  background-color: #ffffff;

  display: flex;
  flex-direction: column;
  justify-content: space-between;

  box-shadow: 0 6px 14px rgba(0, 0, 0, 0.2);
  transition: all 0.3s ease;
}


.custom-step-card:hover {
  transform: translateY(-8px) scale(1.02);
  box-shadow: 0 16px 32px rgba(0, 0, 0, 0.3);

}


.icon-container {
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
}


.icon-container svg {
  transition: transform 0.3s ease;
}

.custom-step-card:hover .icon-container svg {
  transform: scale(1.12);
}


.card-footer-title {
  height: 55px;
  display: flex;
  align-items: center;
  justify-content: center;

  font-weight: 600;
  text-transform: uppercase;

  border-top: 1px solid black;
  background-color: #1e88e5;
  color: #ffffff;

  transition: background-color 0.3s ease;
}


.custom-step-card:hover .card-footer-title {
  background-color: #1565c0;
}


.cursor {
  cursor: pointer;
}

</style>
